import { Col, Form, Input, Row, Select } from "antd";
import React, { useState } from "react";
import s from "./Filters.module.scss";
import {
  useGetBrandListQuery,
  useGetModelsListQuery,
} from "../../redux/apiSlice";
import { useDispatch } from "react-redux";
import { filterCars } from "../../redux/carSlice";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Filters = () => {
  const [selectedBrand, setSelectedBrand] = useState();
  const [modelsByBrand, setModelsByBrand] = useState();
  const [modelValue, setModelValue] = useState(undefined);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    data: brands,
    // isLoading,
    // isSuccess,
    // isError,
    // error,
  } = useGetBrandListQuery();

  const range = (start, stop, step) =>
    Array.from(
      { length: (stop - start) / step + 1 },
      (_, i) => start + i * step
    );

  const currentYear = new Date().getFullYear();
  const years = range(currentYear, currentYear - 50, -1);

  const {
    data: models,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useGetModelsListQuery();

  // const modelsByBrand = brands;

  const selectModels = (value) => {
    const data = models.filter((it) => it.brand.id === value);
    setModelsByBrand(data);
  };

  const findCars = async (values) => {
    navigate("/category/1");
    const filteredCars = {
      brand: values.brand,
      model: values.model,
      year_of_manufacture_from: values.year_from,
      price_from: Number(values.price_from),
      price_till: Number(values.price_to),
    };

    if (filteredCars) {
      dispatch(filterCars(filteredCars));
    }
  };

  return (
    <div className={s.filter}>
      <Form className={s.form} form={form} onFinish={findCars}>
        <Row gutter={0} className={s.row}>
          <Col span={4}>
            <Form.Item name='brand'>
              <Select
                className={s.select}
                placeholder={t("brand")}
                options={brands?.map((it) => ({
                  value: it.id,
                  label: it.name,
                }))}
                value={selectedBrand}
                onSelect={(value) => {
                  setSelectedBrand(value);
                  selectModels(value);
                  setModelValue(undefined);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name='model'>
              <Select
                className={s.select}
                placeholder={t("model")}
                options={modelsByBrand?.map((it) => ({
                  value: it.id,
                  label: it.name,
                }))}
                value={modelValue}
                onSelect={(value) => setModelValue(value)}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item>
              <Select
                name='year_from'
                className={s.select}
                placeholder={t("yearFrom")}
                options={years.map((it) => ({
                  value: it,
                  label: it,
                }))}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name='price_from'>
              <Input className={s.input} placeholder={t("priceFrom")} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name='price_to'>
              <Input className={s.input} placeholder={t("priceTo")} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item>
              <div className={s.btns_wrapper}>
                <button className={s.btn}>{t("find")}</button>
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Filters;
